import { render, staticRenderFns } from "./MessageActionMenu.vue?vue&type=template&id=531c545c&scoped=true"
import script from "./MessageActionMenu.vue?vue&type=script&lang=js"
export * from "./MessageActionMenu.vue?vue&type=script&lang=js"
import style0 from "./MessageActionMenu.vue?vue&type=style&index=0&id=531c545c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c545c",
  null
  
)

export default component.exports